export const LocationTypes = Object.freeze({
	Collection: 'Collection address',
	Business: 'Business address',
});
